/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#f8f9fb" text-color="#4a5568" active-text-color="#007aff">
    <div class="logobox">
      <div class="logo-container">
        <img class="logoimg" src="../assets/img/logo.png" alt="">
        <span v-if="!collapsed" class="logo-text">笑眯眯后台</span>
      </div>
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [

        {
          menuid: 10,
          icon: 'el-icon-date',
          menuname: '活动管理',
          hasThird: null,
          url: null,
          menus: [
 
            {
              menuid: 12,
              icon: 'el-icon-edit-outline',
              menuname: '活动管理',
              hasThird: 'N',
              url: 'activity/Activity',
              menus: null
            }

            
          ]
        },
        {
          menuid: 10,
          icon: 'el-icon-school',
          menuname: '校校管理',
          hasThird: null,
          url: null,
          menus: [
 
            {
              menuid: 12,
              icon: 'el-icon-office-building',
              menuname: '校区管理',
              hasThird: 'N',
              url: 'campus/Campus',
              menus: null
            }

            
          ]
        },
        {
          menuid: 10,
          icon: 'el-icon-video-camera',
          menuname: '视频课程管理',
          hasThird: null,
          url: null,
          menus: [
 
            {
              menuid: 12,
              icon: 'el-icon-tickets',
              menuname: '课程列表',
              hasThird: 'N',
              url: 'videoCourse/VideoCourse',
              menus: null
            }

            
          ]
        },


        {
          menuid: 10,
          icon: 'el-icon-video-play',
          menuname: '直播课程管理',
          hasThird: null,
          url: null,
          menus: [
 
            {
              menuid: 12,
              icon: 'el-icon-microphone',
              menuname: '直播列表',
              hasThird: 'N',
              url: 'liveCourse/LiveCourse',
              menus: null
            }

            
          ]
        },




        {
          menuid: 10,
          icon: 'el-icon-connection',
          menuname: '全系统合作课程管理',
          hasThird: null,
          url: null,
          menus: [
         
          {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程一级内容',
              hasThird: 'N',
              url: 'cooperation/CourseOne',
              menus: null
            },
                     
          {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程二级内容',
              hasThird: 'N',
              url: 'cooperation/CourseTwo',
              menus: null
            },
            {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程三级内容',
              hasThird: 'N',
              url: 'cooperation/CourseThree',
              menus: null
            }
            ,
            {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程四级内容',
              hasThird: 'N',
              url: 'cooperation/CourseFour',
              menus: null
            }
            ,
            {
              menuid: 12,
              icon: 'el-icon-notebook-2',
              menuname: '合作课程内容',
              hasThird: 'N',
              url: 'cooperation/CourseList',
              menus: null
            }

            
          ]
        },
        {
          menuid: 10,
          icon: 'el-icon-present',
          menuname: '漫画原创课程系列',
          hasThird: null,
          url: null,
          menus: [
         
          {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程一级内容',
              hasThird: 'N',
              url: 'cooperationClassify/CourseOneClassify',
              menus: null
            },
                     
          {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程二级内容',
              hasThird: 'N',
              url: 'cooperationClassify/CourseTwoClassify',
              menus: null
            },
            {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程三级内容',
              hasThird: 'N',
              url: 'cooperationClassify/CourseThreeClassify',
              menus: null
            }
            ,
            {
              menuid: 12,
              icon: 'el-icon-document-copy',
              menuname: '合作课程四级内容',
              hasThird: 'N',
              url: 'cooperationClassify/CourseFourClassify',
              menus: null
            }
            ,
            {
              menuid: 12,
              icon: 'el-icon-notebook-2',
              menuname: '合作课程内容',
              hasThird: 'N',
              url: 'cooperationClassify/CourseListClassify',
              menus: null
            }

            
          ]
        },
        {
          menuid: 10,
          icon: 'el-icon-monitor',
          menuname: '平台管理',
          hasThird: null,
          url: null,
          menus: [
         
                        {
              menuid: 12,
              icon: 'el-icon-picture-outline',
              menuname: '轮播图管理',
              hasThird: 'N',
              url: 'terrace/Carousel',
              menus: null
            },
            {
              menuid: 15,
              icon: 'el-icon-picture',
              menuname: '电脑网页分类背景轮播管理',
              hasThird: 'N',
              url: 'terrace/WebCategoryHeroCarousel',
              menus: null
            },
            {
              menuid: 16,
              icon: 'el-icon-monitor',
              menuname: '电视机分类背景轮播管理',
              hasThird: 'N',
              url: 'terrace/TvCategoryHeroCarousel',
              menus: null
            },
            {
              menuid: 17,
              icon: 'el-icon-mobile-phone',
              menuname: '电视更新配置管理',
              hasThird: 'N',
              url: 'terrace/TvUpdateConfig',
              menus: null
            },
            {
              menuid: 14,
              icon: 'el-icon-news',
              menuname: '文章管理',
              hasThird: 'N',
              url: 'terrace/Agreement',
              menus: null
            }
            ,
            {
              menuid: 14,
              icon: 'el-icon-medal',
              menuname: '老师管理',
              hasThird: 'N',
              url: 'teacher/Teacher',
              menus: null
            }
            ,
            {
              menuid: 14,
              icon: 'el-icon-reading',
              menuname: '课程介绍管理',
              hasThird: 'N',
              url: 'teacher/Introduce',
              menus: null
            }
            
          ]
        },
        

      ],
      msg: 'success'
    }
    
    var Admin =  {
          menuid: 111,
          icon: 'el-icon-setting',
          menuname: '系统管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 71,
              icon: 'el-icon-key',
              menuname: '管理员设置',
              hasThird: 'N',
              url: 'system/Admin',
              menus: null
            }
          ]
        }

        var User =  {
          menuid: 1,
          icon: 'el-icon-user',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'el-icon-location-information',
              menuname: '学校地图看板',
              hasThird: 'N',
              url: 'user/SchoolMap',
              menus: null
            },
            {
              menuid: 1,
              icon: 'el-icon-user-solid',
              menuname: '用户列表',
              hasThird: 'N',
              url: 'user/User',
              menus: null
            },
            {
              menuid: 1,
              icon: 'el-icon-user-solid',
              menuname: '漫画原创课程用户列表',
              hasThird: 'N',
              url: 'user/User2',
              menus: null
            }
          ]
        }

        var userdata = JSON.parse(localStorage.getItem("userdata"))

      if (userdata.username=="admin") {
        res.data.push(Admin)
        res.data.push(User)
        
      }
console.log("userdata",userdata)
        
    

    this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style scoped>
/* 隐藏侧边栏所有菜单的下拉箭头 */
.el-menu-vertical-demo >>> .el-submenu__icon-arrow {
  display: none !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 100vh;
}
.el-menu-vertical-demo {
  border: none;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.02);
}
.el-menu-item-group__title {
  padding: 0px;
}
.logobox {
  height: 60px;
  line-height: 60px;
  padding: 10px 0;
  margin-bottom: 10px;
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.logoimg {
  height: 32px;
  width: auto;
}
.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #2d3748;
  letter-spacing: 1px;
}
.el-menu-item i, .el-submenu__title i {
  color: #4a5568; /* 加深图标颜色 */
  margin-right: 10px;
  font-size: 18px;
  transition: all 0.3s;
}
/* 折叠状态下图标居中且更亮 */
.el-menu--collapse .el-submenu__title i,
.el-menu--collapse .el-menu-item i {
  margin: 0;
  font-size: 20px;
  color: #2d3748;
}

.el-menu-item.is-active i {
  color: #007aff;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue